<app-date-controls (dateChange)="getDateChange($event)"></app-date-controls>
<app-image-columns [data]="imageArray" [column]="2" [restPolicy]="'division'"></app-image-columns>
